export default class FileManager {
    private paramFile: FileReader | null = null

    /**
     * Select image
     *
     * @param evt
     */
    public select(evt: Event): Promise<FileReader | null> {
        return new Promise((resolve, reject) => {
            if (! this.isAvailable()) {
                reject('The File APIs are not fully supported in this browser.')
                return
            }

            if (evt.target === null) {
              return
            }
            const target = evt.target as any
            const file = target.files[0] // FileList object

            // Only process image files.
            if (!file.type.match('image.*')) {
                reject('File type cannot be processed')
                return
            }

            const reader = new FileReader()

            // Closure to capture the file information.
            reader.onload = (e) => {
                this.paramFile = e.target as FileReader
                resolve(this.paramFile)
            }

            // Read in the image file as a data URL.
            reader.readAsDataURL(file)
        })
    }

    /**
     * Get selected file info
     *
     * @return FileReader
     */
    get file(): FileReader | null {
        return this.paramFile
    }

    /**
     * Supported File API
     *
     * @access private
     * @return boolean
     */
    private isAvailable(): boolean {
        return (File && FileReader && FileList && Blob) !== undefined
    }
}
